/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Helmet } from 'react-helmet';
import { getMetaTags } from './SeoMetaTagsConstants';

const author = 'Snaphunt';
const siteName = 'Snaphunt';
const IMAGE_DOMAIN = 'https://images.snaphunt.com/assets/images/tesa/';

export function renderMetaTags(page, renderMetaTags, pathname) {
  const content = getMetaTags(page, renderMetaTags, pathname);

  return (
    <Helmet>
      {/* { <----------- Basic starts-------------->} */}
      <link rel="canonical" href={content.URL} />
      <meta
        name="google-site-verification"
        content="8GkaF4JwmdTN2hShRcN5SOtKGU2fGpCi9LYWkrwF7c4"
      />
      <link
        rel="shortcut icon"
        type="image/icon"
        href={`${IMAGE_DOMAIN}favicon.ico`}
      />
      <link
        rel="icon"
        type="image/icon"
        href={`${IMAGE_DOMAIN}favicon-16x16.png`}
      />
      <link href="/favicon.ico" rel="shortcut icon" type="image/x-icon" />
      <link
        rel="apple-touch-icon"
        href={`${IMAGE_DOMAIN}apple-touch-icon.png`}
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href={`${IMAGE_DOMAIN}apple-touch-icon-72x72.png`}
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href={`${IMAGE_DOMAIN}apple-touch-icon-114x114.png`}
      />
      <link
        rel="icon"
        sizes="192x192"
        href={`${IMAGE_DOMAIN}icon-192x192.png`}
      />
      {/* { <----------- Dynamic starts-------------->} */}
      <title>{content.titleContent}</title>
      <meta name="title" content={content.titleContent} />
      <meta name="description" content={content.descriptionContent} />
      <meta name="keywords" content={content.keywordContent} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta charset="UTF-8" />
      <meta name="referrer" content="origin-when-cross-origin" />
      <meta name="theme-color" content="#FFFFFF" />
      {/* <meta
        name="viewport"
        content="width=device-width, initial-scale=1, user-scalable=no, maximum-scale=2"
      /> */}
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="distribution" content="global" />
      <meta content="chrome=1" httpEquiv="X-UA-Compatible" />
      <meta name="google" content="notranslate" />
      {/* <!-- Basic ends --> */}

      {/* <!-- Facebook Starts --> */}
      <meta property="og:description" content={content.descriptionContent} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={content.URL} />
      <meta property="og:title" content={content.titleContent} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image"
        content={content.ogImage ? content.ogImage : content.image}
      />
      {/* <!-- Facebook Ends --> */}
      {/* <!-- Twitter Starts --> */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@snaphuntjobs" />
      <meta name="twitter:creator" content="Snaphunt" />
      <meta name="twitter:creator:id" content="@snaphuntjobs" />
      <meta name="twitter:title" content={content.titleContent} />
      <meta name="twitter:description" content={content.descriptionContent} />
      <meta
        name="twitter:image"
        content={content.twitterImage ? content.twitterImage : content.image}
      />
      <meta name="twitter:url" content={content.URL} />
      {/* <!-- Twitter Ends --> */}
    </Helmet>
  );
}
